import Axios from "../../../Config/API";
import Service from "../../../Service";
import {
    MotivoCancelamentoInterface,
    MotivoCancelamentoInterfaceResponse,
} from "../../../../Interfaces/Geral/GestaoDeCadastro/MotivoCancelamento/MotivoCancelamentoInterfaces";

export function CadastratarMotivoCancelamentoService(
    requestBody: MotivoCancelamentoInterface
) {
    return Service(
        Axios.post<Array<MotivoCancelamentoInterface>>(
            `/cobranca/motivocancelamento/cadastrarmotivocancelamento`,
            requestBody
        )
    );
}
export function EditarMotivoCancelamentoService(
    requestBody: MotivoCancelamentoInterface
) {
    return Service(
        Axios.put(
            `/cobranca/motivocancelamento/atualizarmotivocancelamento`,
            requestBody
        )
    );
}

export function DeletarMotivoCancelamentoService(IDMotivoCancelamento: number) {
    return Service(
        Axios.delete<MotivoCancelamentoInterface>(
            `/cobranca/motivocancelamento/deletarmotivocancelamento?IDMotivoCancelamento=${IDMotivoCancelamento}`
        )
    );
}

export function ListarMotivoCancelamentoService(
    ID_TIPO_CASO: number,
    DS_PESQUISA: string
) {
    return Service(
        Axios.get<Array<MotivoCancelamentoInterfaceResponse>>(
            `/cobranca/motivocancelamento/listarmotivocancelamento?ID_TIPO_CASO=${ID_TIPO_CASO}&DS_PESQUISA=${DS_PESQUISA}`
        )
    );
}
